import { GreyWhite, Box } from '@sequencehq/core-components'
import { TitleEditor } from './TitleEditor'
import { ContentEditor } from './ContentEditor'
import { ConfigPills } from './ConfigPills'
import { QuoteByline } from 'modules/Cube/view/layouts/quote/QuoteEditorContent/QuoteByline/QuoteByline'
import { ValidationBanner } from './ValidationBanner/ValidationBanner'
import { CoverImageEditorUploadButton } from './CoverImageEditor/CoverImageEditor'
import { useCoverImageEditorContext } from './CoverImageEditor/CoverImageEditorContext'
import { useEffect } from 'react'
import { useCubeContext } from 'Cube/communication/internal/cube.domain.context'
import { useFeatureFlags } from 'hooks/useFeatureFlags'
import { QuoteBlockEditorV2 } from './BlockEditorV2/QuoteBlockEditorV2'

export const QuoteEditorContent = () => {
  const ctx = useCubeContext()
  const flags = useFeatureFlags()
  const { imageSrc, isDisabled } = useCoverImageEditorContext()

  /**
   * Blocknote doesn't have a clean way to reinitialize the editor, so we need
   * to remount it when we load in new presentation content (e.g. by applying
   * a template).
   */
  const showEditor =
    !ctx.queries.rawData.editor.quoteEditorNeedsReinitialization
  useEffect(() => {
    if (ctx.queries.rawData.editor.quoteEditorNeedsReinitialization) {
      ctx.mutators.updateEditor({
        quoteEditorNeedsReinitialization: false
      })
    }
  }, [
    ctx.queries.rawData.editor.quoteEditorNeedsReinitialization,
    ctx.mutators
  ])

  return (
    <Box background={GreyWhite}>
      <ValidationBanner />
      <Box px="35px" pt="16px" margin="0 auto" role="group">
        {!isDisabled && (
          <Box
            opacity={!imageSrc ? 1 : 0}
            height={imageSrc ? '0px' : undefined}
            pb="16px"
            px="16px"
          >
            <CoverImageEditorUploadButton data-testid="quote.coverImage.buttonUpload" />
          </Box>
        )}

        <TitleEditor />
        <QuoteByline />
        <ConfigPills />
      </Box>

      <Box>
        <Box pb="64px" margin="0 auto">
          {showEditor &&
            (flags.useBlockEditorV2 ? (
              <QuoteBlockEditorV2 />
            ) : (
              <ContentEditor />
            ))}
        </Box>
      </Box>
    </Box>
  )
}
